import { makeStyles } from '@mui/styles';
import { COLOR_PURPLE } from 'styles/variables/colors';

export const useStyles = makeStyles((theme) => ({
  buttonStateContent: {
    textTransform: 'none',
    fontSize: 14,
    lineHeight: 1.2,

    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  buttonStateContentSelected: {
    color: COLOR_PURPLE,
    fontWeight: 'bold',

    '&::before': {
      display: 'block',
      position: 'absolute',
      top: 45,
      left: '50%',
      content: '""',
      width: 100,
      height: 3,
      backgroundColor: '#7833FF',
      borderRadius: 30,
      transform: 'translateX(-50%)',
    },
  },
  contentTransition: {
    opacity: 1,
    visibility: 'visible',
    transition:
      'opacity 0.5s ease-in-out, visibility 0.5s ease-in-out, max-height 0.5s ease-in-out',
  },
  contentHidden: {
    opacity: 0,
    visibility: 'hidden',
    maxHeight: '0',
    overflow: 'hidden',
    transition:
      'opacity 0.5s ease-in-out, visibility 0.5s ease-in-out, max-height 0.5s ease-in-out',
  },
}));
